var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60%",
    height: "60%",
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67047 1.16454C9.67047 0.717162 9.31059 0.354492 8.86666 0.354492C8.42272 0.354492 8.06284 0.717162 8.06284 1.16454V7.91491H1.36436C0.920428 7.91491 0.560547 8.27758 0.560547 8.72496C0.560547 9.17234 0.920428 9.53501 1.36436 9.53501H8.06284V16.2854C8.06284 16.7328 8.42272 17.0954 8.86665 17.0954C9.31059 17.0954 9.67047 16.7328 9.67047 16.2854V9.53501H16.3689C16.8129 9.53501 17.1728 9.17234 17.1728 8.72496C17.1728 8.27758 16.8129 7.91491 16.3689 7.91491H9.67047V1.16454Z",
    fill: "#32CD32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.83b123d6613174382cecfd6e2c8b1f2e.svg";
export { ForwardRef as ReactComponent };